import React, { useState, useEffect } from "react";
import { Select, MenuItem, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { StyledDatePicker } from "../../../common/components/FilterDashboard/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { StyledButton } from "../../../common/components/Button";
import { getServices } from "../../../api/serviceApi";
import FilterDashboard from "../../../common/components/FilterDashboard/index";
import { getServiceProviders } from "../../../api/serviceProviderApi";
const AppointmentFilterDashboard = ({ getAppointments }) => {
  const [service, setService] = useState([]);
  const [serviceProviders, setServiceProviders] = useState([]);
  const [filterService, setFilterService] = useState(null);
  const [filterServiceProviderId, setFilterServiceProviderId] = useState(null);

  const [filterServiceProvider, setFilterServiceProvider] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const getMyServicesProviders = async (serviceId) => {
    const response = await getServiceProviders(serviceId);
    setServiceProviders(response);
  };
  useEffect(() => {
    const getMyServices = async () => {
      const response = await getServices();
      setService(response);
    };
    getMyServices();
  }, []);

  return (
    <FilterDashboard>
      Appointment Filters
      <Select
        style={{
          height: "30px",
          width: "150px",
          borderRadius: "20px",
          backgroundColor: "#EBE8FC",
          fontFamily: "Inter",
          fontWeight: "700",
          fontSize: "12px",
          marginLeft: "10px",
        }}
        value={filterService}
        onChange={(e) => {
          setFilterService(e.target.value.name);
          getMyServicesProviders(e.target.value.id);
        }}
        displayEmpty
        renderValue={
          filterService !== null
            ? () => <div>{filterService}</div>
            : () => (
                <div style={{ color: "#B0AEBD", fontWeight: "600" }}>
                  Service
                </div>
              )
        }
      >
        {service.map((serv) => {
          return (
            <MenuItem value={{ id: serv.id, name: serv.name }}>
              {serv.name}
            </MenuItem>
          );
        })}
      </Select>
      <Select
        style={{
          height: "30px",
          width: "150px",
          borderRadius: "20px",
          backgroundColor: "#EBE8FC",
          fontFamily: "Inter",
          fontWeight: "700",
          fontSize: "12px",
          marginLeft: "10px",
        }}
        value={filterServiceProvider}
        onChange={(e) => {
          setFilterServiceProviderId(e.target.value.id);
          console.log(e.target.value.name);
          setFilterServiceProvider(e.target.value.name);
        }}
        displayEmpty
        renderValue={
          filterServiceProvider !== null
            ? () => <div>{filterServiceProvider}</div>
            : () => (
                <div style={{ color: "#B0AEBD", fontWeight: "600" }}>
                  Service Provider
                </div>
              )
        }
      >
        {serviceProviders.map((serv) => {
          return (
            <MenuItem value={{ id: serv.id, name: serv.name }}>
              {serv.name}
            </MenuItem>
          );
        })}
      </Select>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <StyledDatePicker
          value={startDate}
          onChange={(startDate) => {
            setStartDate(startDate);
          }}
          format="yyyy-MM-dd"
          renderInput={(params) => {
            console.log(params);
            return (
              <TextField
                {...params}
                inputProps={{
                  ...params.inputProps,
                  placeholder: "Start Date",
                }}
              />
            );
          }}
        />

        <StyledDatePicker
          value={endDate}
          onChange={(endDate) => {
            setEndDate(endDate);
          }}
          displayEmpty
          renderInput={(params) => {
            console.log(params);
            return (
              <TextField
                {...params}
                inputProps={{
                  ...params.inputProps,
                  placeholder: "End Date",
                }}
              />
            );
          }}
        />
      </LocalizationProvider>
      <StyledButton
        style={{ marginLeft: "10px" }}
        theme="green"
        onClick={() => {
          getAppointments(
            filterServiceProviderId,
            new Date(startDate).toLocaleString("en-US"),
            new Date(endDate).toLocaleString("en-US"),
            filterService
          );
        }}
      >
        Search
      </StyledButton>
    </FilterDashboard>
  );
};

export default AppointmentFilterDashboard;
